import i18n from "config/i18next";

i18n.addResources("es", "templateDetail", {
  code: "Código de plantilla",
  updatedAt: "Última actualización",
  detail: "Edición de plantilla",
  regionLabel: "Región *",
  workzoneLabel: "Zona de operación *",
  slotStartLabel: "Comienzo del turno *",
  slotEndLabel: "Fin del turno *",
  regionPlaceholder: "Seleccioná la región",
  workzonePlaceholder: "Seleccioná la zona",
  slotStartPlaceholder: "Ingresá el horario de comienzo",
  slotEndPlaceholder: "Ingresá el horario de finalización",
  deleteTitle: "Estás por eliminar la plantilla",
  deleteMessage: "¿Realmente querés eliminarla?",
  deleteErrorTitle: "No es posible eliminar esta plantilla",
  deleteErrorMessage: "Por favor, verificá e intentá nuevamente",
  updateTemplateTitle: "Estás por actualizar una plantilla",
  updateTemplateMessage:
    "Los cambios estarán visibles a partir de {{date}} a las {{time}}hs",
  validTitle: "Plantilla actualizada con éxito",
  validMessage: "La plantilla fue actualizada correctamente",
});
